/**
 * DB用の値 serviceYears を、学年表示用の値（1〜4）に変換
 */
export default function convertToGrade(serviceYears) {
    switch (serviceYears) {
        case 6: return '1';
        case 7: return '2';
        case 8: return '3';
        case 9: return '4';
        default: return '-';
    }
}
